import React from "react";
import Card from "@/components/Card";

import { Form, Select } from "antd";
import { useRootSelector } from "@/infrastructure/hooks";
import { BacktestAction, BacktestSel } from "@/features/backtest";
import { useDispatch } from "react-redux";
import RangeOption from "./RangeOption";

const { Option } = Select;

export default () => {
  const dispatch = useDispatch();
  const ticker = useRootSelector(BacktestSel.ticker);
  const isTickerLoading = useRootSelector(BacktestSel.isTickerLoading);
  const region = useRootSelector(BacktestSel.region);
  const availRegions = useRootSelector(BacktestSel.availRegions);
  const availTickers = useRootSelector(BacktestSel.availTickers);

  return (
    <Card title={"Backtest Options"}>
      <Form.Item
        label="Select Market"
        name={"region"}
        rules={[{ required: true, message: "Please select the exchange market!" }]}
        initialValue={region}
      >
        <Select
          placeholder="Please select a region"
          style={{ width: "93%" }}
          onChange={e => dispatch(BacktestAction.updateSetup({ region: e as string, ticker: [] }))}
        >
          {availRegions.map(e => (
            <Option key={e} value={e}>
              {e}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Select Tickers"
        name={"ticker"}
        rules={[{ required: true, message: "Search and select at least one ticker" }]}
        initialValue={ticker}
      >
        <Select
          showSearch
          loading={isTickerLoading}
          mode={"multiple"}
          placeholder="Please select at least one ticker"
          style={{ width: "93%" }}
          filterOption={false}
          onChange={e => dispatch(BacktestAction.updateSetup({ ticker: e as string[] }))}
          onSearch={e => dispatch(BacktestAction.fetchTickers.request({ region, text: e }))}
        >
          {availTickers.map(e => (
            <Option key={e.symbol} value={e.symbol}>
              [{e.symbol}] {e.shortname || e.longname}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <RangeOption />
    </Card>
  );
};
